import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';

export const fetchAnalyticsSummary = createAsyncThunk('analytics/summary', async (query='', { rejectWithValue }) => {
	try {
		const res = await axiosInstance.get(`/admin/analytics/summary${query}`);
		return res.data.summary;
	} catch (e){
		return rejectWithValue(e.response?.data || e.message);
	}
});

export const fetchAnalyticsEvents = createAsyncThunk('analytics/events', async (query='', { rejectWithValue }) => {
	try {
		const res = await axiosInstance.get(`/admin/analytics/events${query}`);
		return res.data.events;
	} catch (e){
		return rejectWithValue(e.response?.data || e.message);
	}
});
export const deleteAnalyticsEvents = createAsyncThunk('analytics/events/delete', async (ids=[], { rejectWithValue }) => {
	try {
		const res = await axiosInstance.delete(`/admin/analytics/events/bulk`, { data:{ ids } });
		return res.data;
	} catch (e){
		return rejectWithValue(e.response?.data || e.message);
	}
});

const analyticsSlice = createSlice({
	name:'analytics',
	initialState: {
		loadingSummary:false,
		loadingEvents:false,
		summary:null,
		events:[],
		error:null,
		filter:{ from:'', to:'', path:'', event:'', limit:50 },
	},
	reducers: {
		setAnalyticsFilter(state, action){
		state.filter = { ...state.filter, ...action.payload };
		}
	},
	extraReducers: (builder)=>{
		builder
		.addCase(fetchAnalyticsSummary.pending, (s)=>{ s.loadingSummary=true; s.error=null; })
		.addCase(fetchAnalyticsSummary.fulfilled, (s,a)=>{ s.loadingSummary=false; s.summary=a.payload; })
		.addCase(fetchAnalyticsSummary.rejected, (s,a)=>{ s.loadingSummary=false; s.error=a.payload; })
		.addCase(fetchAnalyticsEvents.pending, (s)=>{ s.loadingEvents=true; s.error=null; })
		.addCase(fetchAnalyticsEvents.fulfilled, (s,a)=>{ s.loadingEvents=false; s.events=a.payload; })
		.addCase(fetchAnalyticsEvents.rejected, (s,a)=>{ s.loadingEvents=false; s.error=a.payload; });
	}
});

export const { setAnalyticsFilter } = analyticsSlice.actions;
export default analyticsSlice.reducer;
